<script lang="ts" setup>
  import { ExternalRoute } from "@/constants/externalRoute"
  import Link from "@/components/ui/link/Link.vue"
</script>
<template>
  <h4>We're sorry to hear you don't want to continue your switch</h4>
  <p>
    We hope you might change your mind once you get to know us a bit better. If
    you still want to cancel your switch, no hard feelings,
    <Link :to="ExternalRoute.aboutUs" class="link text-primary-600">
      but here are a few good reasons to stay with So Energy.
    </Link>
  </p>
</template>
